import React from 'react';
import { useTheme } from '@material-ui/core/styles';

const ErrorIcon = (props) => {
  const theme = useTheme();

  return (
    <svg
      className={props.className}
      width="35rem"
      height="35rem"
      viewBox="0 0 512 526"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M322.828 322.828V128.828H259.172V322.828H322.828ZM291 462.266C302.115 462.266 311.966 458.225 320.555 450.141C329.144 441.55 333.438 431.45 333.438 419.829C333.438 408.713 329.144 399.116 320.555 391.033C312.471 382.949 302.62 378.908 291 378.908C279.885 378.908 270.034 382.949 261.445 391.033C252.857 398.609 248.562 408.208 248.562 419.829C248.562 430.942 252.604 440.794 260.688 449.382C269.276 457.973 279.38 462.266 291 462.266ZM412.25 0L582 169.75V412.25L412.25 582H169.75L0 412.25V169.75L169.75 0H412.25Z"
        fill={theme.palette.footerBackground}
      />
    </svg>
  );
};

export default ErrorIcon;
